const DESKTOP_SCROLL_MEDIA = '(min-width: 1024px)';

export function clearFacetAccordionScrollStyle(el) {
  if (!(el instanceof HTMLElement)) return;
  el.style.removeProperty('min-height');
  el.style.removeProperty('max-height');
  el.style.removeProperty('overflow-y');
  el.style.removeProperty('overscroll-behavior-y');
}

export function applyFacetAccordionScrollStyle(el) {
  if (!(el instanceof HTMLElement)) return;
  if (!el.hasAttribute('data-facet-scroll-expanded')) {
    clearFacetAccordionScrollStyle(el);
    return;
  }
  if (!window.matchMedia(DESKTOP_SCROLL_MEDIA).matches) {
    clearFacetAccordionScrollStyle(el);
    return;
  }
  el.style.minHeight = '0';
  el.style.maxHeight = 'min(55vh, 26rem)';
  el.style.overflowY = 'auto';
  el.style.overscrollBehaviorY = 'contain';
}

export function syncAllExpandedFacetScrollSurfaces(root = document) {
  root.querySelectorAll('[data-facet-list-scroll][data-facet-scroll-expanded]').forEach(el => {
    applyFacetAccordionScrollStyle(el);
  });
}
